import * as UserActions from './../actions/user.actions';
import * as UserSelectors from './../selectors/user.selectors';
import * as CoreActions from './../actions/core.actions';
import * as MessengerState from '@messenger/_store/messenger.actions';

import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, exhaustMap, map, switchMap, take} from 'rxjs/operators';
import {of} from 'rxjs';
import {LocalStorageService} from '@common/services/local.storage.service';
import {UserService} from '@common/services/user.service';
import {CoreService} from '@common/services/core.service';
import {MinimizedDialogsService} from '@common/services/minimized-dialogs.service';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {DahPermissions, PermissionsEnum} from '@common/models/user.models';


@Injectable()
export class UserEffects {
    updatePermissionsByCompanyCabinetAccess$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserActions.SetCabinetAccessSuccess),
            switchMap(() => {
                return this.store$.select(UserSelectors.getUserState).pipe(
                    take(1),
                    map((state) => {
                        const permissionsToRemove: PermissionsEnum[] = [
                            'AC_ACCRUAL_DOC_EDIT',
                        ];

                        const updatedPermissions: DahPermissions = {
                            ...state.permissions
                        };

                        state.cabinetAccess?.companyAccess?.forEach(company => {
                            const uuid = company.id;

                            if (!updatedPermissions[uuid]?.length) {
                                return;
                            }

                            updatedPermissions[uuid] = updatedPermissions[uuid].filter(
                                permission => !permissionsToRemove.includes(permission)
                            );
                        });

                        return UserActions.SetPermissionsSuccess({
                            payload: updatedPermissions
                        });
                    })
                );
            })
        );
    });

    logoutUser$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserActions.LogOut),
            exhaustMap(() => {
                return this.userService.logoutUser().pipe(
                    switchMap(() => {
                        return of(UserActions.LogOutSuccess());
                    }),
                    catchError(() => {
                        return of(UserActions.LogOutSuccess());
                    })
                );
            })
        );
    });

    logoutUserSuccess$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserActions.LogOutSuccess),
            exhaustMap(() => {
                this.minimizedDialogService.closeAllMinimizedDialogs();
                this.dialog.closeAll();
                this.localStorageService.clear();
                this.userService.clearTempToken();
                this.coreService.clearCurrentCabinet();
                return of(UserActions.SetInitialState(), CoreActions.SetAllInitialStates({keepFirstPage: false}), MessengerState.SetInitialState());
            })
        );
    }, {dispatch: false});

    constructor(
        private actions$: Actions,
        private store$: Store,
        private localStorageService: LocalStorageService,
        private userService: UserService,
        private coreService: CoreService,
        private minimizedDialogService: MinimizedDialogsService,
        private dialog: MatDialog
    ) {
    }
}
